<template lang="pug">
    ul
        li
            h4 Regions
        li
            router-link(:to="{ query: { ...$route.query, region: null } }")
                flag(code="world")
                | All regions
        li(v-for="r in Regions") 
            router-link(:to="{ query : { ...$route.query, region: r.id }}")
                flag(:code="r.iso_3166_2")
                | {{ r.name }}
</template>

<script>
import gql from "graphql-tag";
import { sortBy } from "lodash";

export default {
	apollo: {
		Regions: {
			query: gql`
				query Regions($installed: Boolean!) {
					Regions(installed: $installed) {
						id
						name
						iso_3166_2
						school_count
					}
				}
			`,
			variables: {
				installed: true
			},
			update: r => sortBy(r.Regions, "school_count")
		}
	}
};
</script>
